import React, { memo } from 'react';
import { Alert, Button, Form, Input, Modal, Row, Space, Tooltip } from 'antd';
import { FrownOutlined, InfoCircleOutlined, SmileOutlined } from '@ant-design/icons';
import { useDispatch, useSelector } from 'react-redux';
import { ApplicationState } from '../../../../store';
import {
  loadRequestUpdate,
  loadRequest as loadOcorrencia,
} from '../../../../store/ducks/ocorrencia/actions';
import { sendMenssageRequest } from '../../../../store/ducks/sendMenssages/actions';
import { loadRequest } from '../../../../store/ducks/progressBarSLA/actions';
import { openNotification } from '../../Utils';
import { Props, FormValues } from './types';
import api from '../../../../service/api';
import { SKW_PREFIX } from '../../../../utils/constants';
import SelectSolicitao from '../../components/SelectSolicitacao';

const App: React.FC<Props> = ({
  open,
  setOpen,
  modification,
  setShowDepartamento,
  currentSolicitacao,
}) => {
  const [form] = Form.useForm();
  const dispatch = useDispatch();
  const token = useSelector((state: ApplicationState) => state.auth.token);
  const protocolo = useSelector(
    (state: ApplicationState) => state.Ocorrencia?.data['ocorrencia']?.protocolo
  );

  const [loading, setLoading] = React.useState<boolean>(false);
  const [showTipoSolicitacao, setShowTipoSolicitacao] = React.useState<boolean>(false);

  const onFinish = (values: FormValues) => {
    setLoading(true);
    if (values.interno.trim() !== '' && values.externo.trim() !== '') {
      api
        .post(`call?serviceName=${SKW_PREFIX}atualizaOcorrencia&token=${token}`, {
          protocolo: protocolo,
          justificativa: values?.interno,
          tipoSolicitacao: values?.tipoSolicitacao,
          ...modification,
        })
        .then(() => {
          dispatch(sendMenssageRequest(protocolo, values?.externo));
          dispatch(loadOcorrencia(protocolo));
          dispatch(loadRequest(protocolo));
          if (setShowDepartamento) setShowDepartamento(false);
          form.resetFields();
          setOpen(false);
          setLoading(false);
          openNotification('Ok!', <SmileOutlined />, 'Alteração efetuada com sucesso!');
        })
        .catch(() => {
          openNotification('Ops!', <FrownOutlined />, 'Não foi possível efetuar essa alteração!');
          setLoading(false);
        });
    } else {
      openNotification('Ops!', <FrownOutlined />, 'Não foi possível efetuar essa alteração!');
      setLoading(false);
    }
  };

  const onFinishFailed = (errorInfo: any) => {
    console.error('Failed:', errorInfo);
    if (setShowDepartamento) setShowDepartamento(false);
    openNotification('Ops!', <FrownOutlined />, 'Não foi possível efetuar essa alteração!');
  };

  return (
    <Modal
      title="Informe o motivo da alteração"
      visible={open}
      confirmLoading={loading}
      footer={null}
      onCancel={() => {
        setShowTipoSolicitacao(false);
        setOpen(false);
        if (setShowDepartamento) setShowDepartamento(false);
        dispatch(loadRequestUpdate(protocolo));
      }}
    >
      <Form layout="vertical" onFinish={onFinish} onFinishFailed={onFinishFailed} form={form}>
        {currentSolicitacao && !showTipoSolicitacao && (
          <Alert
            message={<strong>Precisa alterar o tipo de solicitação?</strong>}
            type="warning"
            banner
            action={
              <Space>
                <Button size="small" type="link" onClick={() => setShowTipoSolicitacao(true)}>
                  Clique aqui
                </Button>
              </Space>
            }
            // closable
          />
        )}

        {currentSolicitacao && showTipoSolicitacao && (
          <SelectSolicitao currentSolicitacao={currentSolicitacao} />
        )}
        <Form.Item
          label={
            <Space>
              Justificativa externa
              <Tooltip title="Essa informação estará disponível para todos na conversa">
                <InfoCircleOutlined />
              </Tooltip>
            </Space>
          }
          name="externo"
          rules={[
            {
              required: true,
              message: <span style={{ color: 'red' }}>Por favor preencha este campo!</span>,
            },
          ]}
        >
          <Input.TextArea placeholder="Informe aqui sua justificativa" />
        </Form.Item>

        <Form.Item
          label={
            <Space>
              Justificativa interna
              <Tooltip title="Essa informação somente estará disponível internamente">
                <InfoCircleOutlined />
              </Tooltip>
            </Space>
          }
          name="interno"
          rules={[
            {
              required: true,
              message: <span style={{ color: 'red' }}>Por favor preencha este campo!</span>,
            },
          ]}
        >
          <Input.TextArea placeholder="Definições técnicas" />
        </Form.Item>

        <Row style={{ display: 'flex', justifyContent: 'flex-end' }}>
          <Space>
            <Button
              type="default"
              onClick={() => {
                setShowTipoSolicitacao(false);
                if (setShowDepartamento) setShowDepartamento(false);
                setOpen(false);
                dispatch(loadRequestUpdate(protocolo));
              }}
            >
              Cancelar
            </Button>

            <Button data-cy="btn-confirm-modal" type="primary" htmlType="submit" loading={loading}>
              Confirmar
            </Button>
          </Space>
        </Row>
      </Form>
    </Modal>
  );
};

export default memo(App);
